import { useSSRContext } from './state';
import * as pino from 'pino';
export function getLogger() {
    if (import.meta.env.SSR) {
        const ctx = useSSRContext();
        if (ctx?.logger)
            return ctx.logger;
    }
    // This is slightly cursed, but if we require pino in a node env pino.default
    // exists (as well as pino.pino tbh) so a normal import pino from 'pino' would
    // work. But pino ships a special
    return (pino.default ?? pino)({ level: 'trace' });
}
//# sourceMappingURL=logger.js.map